import React from 'react'
import PropTypes from 'prop-types'

import { getAdClickThroughLink } from '../../helpers'

import useStyles from './styles'

const LinkSectionPreview = ({ ad }) => {
  const classes = useStyles()

  const link = getAdClickThroughLink(ad)

  if (!link) {
    return null
  }

  return <p className={classes.linkPreview}>{link}</p>
}

LinkSectionPreview.propTypes = {
  ad: PropTypes.object
}

export default LinkSectionPreview
